import { API_ENDPOINTS } from "@/api/services/employeeList/ApiEndPoints";
import { baseApi } from "@/utils/baseApi";

export const employeeListApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchEmployeesByParentOrg: builder.query({
      query: () => ({
        url: API_ENDPOINTS.GET_EMPLOYEE(),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["EmployeeList"],
    }),

    getReviewers: builder.query({
      query: () => ({
        url: API_ENDPOINTS.GET_REVIWER(),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["EmployeeList"],
    }),

    RMUnderReviewer: builder.query({
      query: (empId) => ({
        url: API_ENDPOINTS.GET_REVIEWER_BY_REP(empId),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["ReportingManager"],
    }),

    empUnderRM: builder.query({
      query: (empId) => ({
        url: API_ENDPOINTS.GET_EMP_UNDER_RM(empId),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["EmployeeList"],
    }),

    accessType: builder.query({
      query: () => ({
        url: API_ENDPOINTS.ACCESS_TYPE(),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["AccessType"],
    }),

    getRolesbyOrg: builder.query({
      query: (data) => ({
        url: API_ENDPOINTS.GET_ROLES_BY_ORG(data),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["Roles"],
    }),

    roleType: builder.query({
      query: () => ({
        url: API_ENDPOINTS.ROLE_TYPE(),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["RoleType"],
    }),

    getOrgBasedEmployee: builder.query({
      query: () => ({
        url: API_ENDPOINTS.GET_ORG_BASED_EMPLOYEE(),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["Organization"],
    }),

    getEmployees: builder.query({
      query: (filterData) => ({
        url: API_ENDPOINTS.EMPLOYEE_LIST(),
        method: "GET",
        params: filterData,
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["EmployeeList"],
    }),

    addEmployee: builder.mutation({
      query: (formData) => ({
        url: `employee`,
        method: `POST`,
        body: formData,
      }),
      invalidatesTags: ["EmployeeList"],
    }),

    editRole: builder.mutation({
      query: ({ empID, formData }) => ({
        url: API_ENDPOINTS.EDIT_ROLE(empID),
        method: "PUT",
        body: formData,
      }),
      transformResponse: (response) => response?.data,
      transformErrorResponse: (res) => res?.error,
      invalidatesTags: ["EmployeeList", "Roles"],
    }),

    editOrganazation: builder.mutation({
      query: ({ empID, formData }) => ({
        url: API_ENDPOINTS.EDIT_ORGANAZATION(empID),
        method: "PUT",
        body: formData,
      }),
      transformResponse: (response) => response?.data,
      invalidatesTags: ["EmployeeList", "Organization", "SubOrganization"],
    }),

    getSubOrganization: builder.query({
      query: (empID) => ({
        url: API_ENDPOINTS.GET_SUB_ORG(empID),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["SubOrganization"],
    }),

    getOrganization: builder.query({
      query: (parentOrg, isParent) => ({
        url: API_ENDPOINTS.GET_ORG(parentOrg, isParent),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["Organization"],
    }),

    updateIdCard: builder.query({
      query: (empID) => ({
        url: API_ENDPOINTS.EDIT_ID_CARD_INFO(empID),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["IDCard"],
    }),

    reportingManagerUnderReviewer: builder.query({
      query: (empId) => ({
        url: API_ENDPOINTS.GET_RM_UNDER_RW(empId),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["ReportingManager"],
    }),

    employeesUnderRM: builder.query({
      query: (empId) => ({
        url: API_ENDPOINTS.GET_EMP_UNDER_RM(empId),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["EmployeeList"],
    }),

    downloadSampleFile: builder.mutation({
      query: () => ({
        url: API_ENDPOINTS.DOWNLOAD(),
        method: "GET",
        responseHandler: async (response) => response.blob(),
        extraOptions: { isMultipart: true },
      }),
    }),
    addEmployeeBulkUpload: builder.mutation({
      query: ({ data, opt }) => ({
        url: API_ENDPOINTS.BULK_UPLOAD(opt), // opt = Insert or Update
        method: "POST",
        body: data,
        responseHandler: (response) => response.blob(),
      }),
      invalidatesTags: ["EmployeeList"],
    }),

    updateIdCardPut: builder.mutation({
      query: ({
        empId,
        empRelation,
        nameOfRelation,
        contactNo,
        bloodGroup,
        status,
      }) => ({
        url: API_ENDPOINTS.POST_ID_CARD(
          empId,
          empRelation,
          nameOfRelation,
          contactNo,
          bloodGroup,
          status
        ),
        method: "PUT",
      }),
      invalidatesTags: ["IDCard", "EmployeeList"],
    }),

    getRecruiter: builder.query({
      query: (role) => ({
        url: API_ENDPOINTS.GET_REC(role),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["Recruiter"],
    }),

    getRwrByRm: builder.mutation({
      query: (rmId) => ({
        url: API_ENDPOINTS.GET_REVIEWER_BY_RM(rmId),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
    }),

    getDivisionByDept: builder.mutation({
      query: (dept) => ({
        url: API_ENDPOINTS.GET_DIVISION_BY_DEPT(dept),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
    }),

    // mail id domain based org list
    getDomainBasedOrgList: builder.query({
      query: () => ({
        url: API_ENDPOINTS.GET_DOMAIN_BASED_ORG_LIST(),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["DomainBasedOrgList"],
    }),

    getExport: builder.query({
      query: (filterData) => ({
        url: API_ENDPOINTS.EXPORT(),
        method: "GET",
        params: filterData,
        responseHandler: (response) => response.blob(), // ⬅️ Ensures file stream handling
      }),
      extraOptions: { isExport: true },
      providesTags: ["Export"],
    }),

    //ADD SPOC
    addSpoc: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.ADD_SPOC(),
        method: `POST`,
        body: formData,
      }),
      invalidatesTags: ["EmployeeList"],
    }),
  }),
});

export const {
  useGetRecruiterQuery,
  useAccessTypeQuery,
  useRoleTypeQuery,
  useGetOrgBasedEmployeeQuery,
  useGetRolesbyOrgQuery,
  useFetchEmployeesByParentOrgQuery,
  useGetReviewersQuery,
  useRMUnderReviewerQuery,
  useEmpUnderRMQuery,
  useGetEmployeesQuery,
  useAddEmployeeMutation,
  useDownloadSampleFileMutation,
  useEditRoleMutation,
  useEditOrganazationMutation,
  useGetSubOrganizationQuery,
  useUpdateIdCardQuery,
  useReportingManagerUnderReviewerQuery,
  useEmployeesUnderRMQuery,
  useUpdateIdCardPutMutation,
  useLazyGetOrganizationQuery,
  useGetOrganizationQuery,
  useAddEmployeeBulkUploadMutation,
  // get rwr by rm
  useGetRwrByRmMutation,
  useGetDivisionByDeptMutation,
  // domain org list
  useGetDomainBasedOrgListQuery,

  // export
  useLazyGetExportQuery,
  // ADD SPOC
  useAddSpocMutation,
} = employeeListApi;
